import React from "react";
import { observer } from "mobx-react";
import { PillarModel } from "../../models/PillarModel";
import StoriesStore from "../../stores/StoriesStore";
import PillarItem from "./PillarItem";
import Loader from "../../components/Loader";
import { imagePreloader } from "../../utils/ImagePreloader";
import {
  ContentImagePath,
  ContentArticleImagePath,
} from "../../utils/ContentMediaPath";

interface PillarsState {
  isImagesReady: boolean;
}

interface PillarsProps {
  store: StoriesStore;
  selectedPillar?: number;
  history?: any;
}

@observer
class Pillars extends React.Component<PillarsProps, PillarsState> {
  constructor(props: PillarsProps) {
    super(props);

    this.state = {
      isImagesReady: false,
    };

    this.preloadImages = this.preloadImages.bind(this);
  }

  preloadImages(): void {
    const imagesToPreload = [];
    const { store } = this.props;
    const { pillars, getPillarArticles } = store;

    pillars.map((pillar, a): void => {
      //Pillar images
      if (pillar.fullImage)
        imagesToPreload.push(ContentImagePath(pillar.fullImage));
      if (pillar.menuImage)
        imagesToPreload.push(ContentImagePath(pillar.menuImage));

      //Load the first 5 from each pillar
      store.getPillarArticles(pillar).map((article, i): void => {
        if (i < 5 && article.imageUrl)
          imagesToPreload.push(ContentArticleImagePath(article.imageUrl));
      });
    });

    imagePreloader(
      imagesToPreload,
      (images) => {
        this.setState({ isImagesReady: true });
      },
      () => {
        console.log("Failed to load an image");
        this.setState({ isImagesReady: true });
      }
    );
  }

  componentWillMount(): void {
    const { store } = this.props;
    store.deselectPillar();

    if (!this.state.isImagesReady) {
      this.preloadImages();
    }
  }

  componentWillReceiveProps(props) {
    const { store, selectedPillar } = props;
    const { selectPillar, pillars } = store;

    if (selectedPillar !== null) selectPillar(pillars[selectedPillar]);
  }

  render() {
    const { store, history } = this.props;
    const { isImagesReady } = this.state;

    return (
      <div
        className={`pillars ${
          store.isAnyPillarSelected ? "pillars--selected" : ""
        }`}
      >
        {store.pillars.map((pillar, index) => {
          return (
            <PillarItem
              key={index}
              pillar={pillar}
              store={store}
              history={history}
            />
          );
        })}

        <Loader isLoading={!isImagesReady} isPositionRelative={true} />
      </div>
    );
  }
}

export default Pillars;
